import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoWarningTriangle = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>WarningTriangle</title>
    <path
      d="M14.48 4.864c.64-1.229 2.398-1.229 3.039 0l10.886 20.865a1.714 1.714 0 0 1-1.52 2.507H5.113a1.714 1.714 0 0 1-1.52-2.507L14.479 4.864Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path d="M16 11.482v7.498" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path stroke="currentColor" strokeWidth={2.5} strokeLinejoin="round" d="M15.995 22.998h.01v.01h-.01z" />
  </svg>
);
export default SvgIcoWarningTriangle;
